import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Department } from "./department.model";

@Injectable()
export class DepartmentService extends CrudService {
  getRootUrl(): string {
    return "departments";
  }

  save(department: Department) {
    return super.save(department);
  }

  saveMultiple(departments: Array<Department>) {
    return super.saveMultiple(departments);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/shared/department.service.ts